import { render, staticRenderFns } from "./ReportDashboard.vue?vue&type=template&id=04096de0"
import script from "./ReportDashboard.vue?vue&type=script&lang=js"
export * from "./ReportDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04096de0')) {
      api.createRecord('04096de0', component.options)
    } else {
      api.reload('04096de0', component.options)
    }
    module.hot.accept("./ReportDashboard.vue?vue&type=template&id=04096de0", function () {
      api.rerender('04096de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/ReportDashboard.vue"
export default component.exports